export const delay = async (time) => {
    return new Promise((resolve) => setTimeout(resolve, time))
}

export const timeout = async (promise, timeout) => {
    return new Promise((resolve, reject) => {
        delay(timeout).then(() => reject('timeout'))
        promise.then(resolve).catch(reject)
    })
}
